import SearchableDialPad from "Components/shared/SearchableDialPad/SearchableDialPad";
import { useGlobalDialpad } from "Services/state/layout/useGlobalDialpad";

/**
 * App-level container for the global SearchableDialPad modal.
 * This component should be rendered once at the app level (in AppLayout).
 * It reads from the global layout Redux state to control visibility.
 */
export function SearchableDialPadContainer(): JSX.Element | null {
    const { isOpen, defaultPhoneNumber, closeDialpad } = useGlobalDialpad();

    if (!isOpen) {
        return null;
    }

    return <SearchableDialPad onCancel={closeDialpad} defaultSearchInput={defaultPhoneNumber} />;
}
